module.exports = __webpack_public_path__ + "media/images/home/blue-arrow-09ce18b681520ce965695a4c411eeff7.png";